import React from 'react';
import { Button } from './ui/button';
import { Shield } from 'lucide-react';

const HeroSection = ({ onOpenModal }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#2B0A12] via-[#3D1C24] to-[#2B0A12] overflow-hidden">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#D72638] rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#FFB400] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center space-x-2 bg-[#3D1C24] px-4 py-2 rounded-full mb-8 border border-[#FFB400]/20">
          <Shield className="h-4 w-4 text-[#FFB400]" />
          <span className="text-sm text-[#F1F1F1]">Trusted IP Law Experts</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          <span className="text-[#F1F1F1]">Secure Your Innovation.</span>
          <br />
          <span className="bg-gradient-to-r from-[#FFB400] to-[#D72638] bg-clip-text text-transparent">
            Defend Your Legacy.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
          Trademark Essential delivers comprehensive intellectual property protection—from trademark registration to patent filing and corporate formation. Partner with experienced IP attorneys who safeguard what matters most: your brand, your creations, and your competitive edge.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={() => onOpenModal && onOpenModal('Start Trademark Registration - Hero Section')}
            className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold text-lg px-8 py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Start Trademark Registration
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => onOpenModal && onOpenModal('Discuss with Attorney - Hero Section')}
            className="border-2 border-[#D72638] text-[#F1F1F1] hover:bg-[#D72638] hover:text-white font-semibold text-lg px-8 py-6 rounded-lg transition-all duration-300 hover:scale-105"
          >
            Discuss with Attorney
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#FFB400] rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#FFB400] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;